
<template>
  <div class="body">
    <!-- 待签收 -->
    <baseBreadcrumb :page="$t('message.pendienteDeFirma')" :menu="$t('message.emergencyItems')" />
    <div class="body">
      <div class="search">
        <div class="start">
          <!-- 请输入物流号 -->
          <div class="item">
            <el-input :placeholder="$t('message.pleaseEnterTheLogisticsNumber')" v-model="data.express_no"
              onfocus="this.select()" clearable>
            </el-input>
          </div>
          <!-- 按钮 -->
          <div class="item">
            <el-button type="primary" @click="search">{{
              $t("message.search")
            }}</el-button>
            <!-- <el-button @click="reset">{{ $t("message.reset") }}</el-button> -->
          </div>
        </div>
        <div class="end">
          <!-- 新增 -->
          <el-button type="primary" @click="add" v-if="isAuth(297)">{{
            $t("message.add")
          }}</el-button>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" ref="multipleTable" v-if="show">
          <el-table-column align="center" label="NO" prop="rowNumber" width="60">
          </el-table-column>

          <!--  提出时间-->
          <el-table-column align="center" :label="$t('message.forwardTime')" prop="created_at" width="150px">
          </el-table-column>

          <!--  部门-->
          <el-table-column align="center" :label="$t('message.department')" prop="type_name">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.admin" :key="index">
                {{ item.role[0].organization.name }}
              </p>
            </template>
          </el-table-column>

          <!--  提交人-->
          <el-table-column align="center" :label="$t('message.submitOne')" prop="created_by_name">
          </el-table-column>
          <!-- 物流号 -->
          <el-table-column align="center" :label="$t('message.logisticsNumber')" prop="express_no">
          </el-table-column>
          <!-- 交易号 -->
          <el-table-column align="center" :label="$t('message.transactionNumber')" width="180px">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.order_purchase_express" :key="index">
                {{ item.order_purchase.purchase_no }}
              </p>
            </template>
          </el-table-column>

          <!-- 订单号 -->
          <el-table-column align="center" :label="$t('message.orderNumber')" width="180px">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.order_purchase_express" :key="index">
                <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_purchase.order_sn" target="_blank"
                  style="color:#b4272d">{{
                    item.order_purchase.order_sn }}</router-link> <br />
                {{ item.order_purchase.user.realname }}
              </p>
            </template>
          </el-table-column>
          <!-- 操作员 -->
          <el-table-column align="center" :label="$t('message.operator')" prop="created_by_name">
          </el-table-column>
          <!-- 类别 -->
          <el-table-column align="center" :label="$t('message.category')" prop="type_name">
          </el-table-column>
          <!-- 提出人备注 -->
          <el-table-column align="center" :label="$t('message.remarksOfProposer')" prop="remark">
          </el-table-column>
          <!--  操作-->
          <el-table-column align="center" :label="$t('message.operation')" prop="rowNumber" width="150px">
            <template slot-scope="scope">
              <!-- 删除 -->
              <el-button size="small" type="success" class="dark" @click="urgentDelete(scope.row.id)"
                v-if="isAuth(299)">{{
                  $t("message.delete") }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="data.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="data.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 紧急件新增 -->

    <el-dialog :title="$t('message.urgentItemsAdded')" :close-on-click-modal="false" :visible.sync="urgenDialogVisible"
      width="475px" center>
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- 物流号 -->
          <el-form-item :label="$t('message.logisticsNumber') + ':'" prop="express_no">
            <el-input v-model="ruleForm.express_no"></el-input>
          </el-form-item>
          <!-- 类别选择 -->
          <el-form-item :label="$t('message.category') + ':'" prop="type">
            <el-select v-model="ruleForm.type" :placeholder="$t('message.categorySelection')">
              <el-option v-for="item in urgentStatus" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 备注 -->
          <el-form-item :label="$t('message.remark') + ':'" prop="remark">
            <el-input v-model="ruleForm.remark" type="textarea" rows="4" resize="none"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="urgenDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="urgentStore">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { optionType, urgentStatus } from "@/utlis/options";

export default {
  data() {
    return {
      tableData: [{}],
      id: 0, // 修改ID
      show: true,
      data: {
        page: 1,
        pageSize: 10,
        express_no: "",
        status: "0",
      },
      express_no: "",
      total: 0,

      optionType,
      //   紧急件新增
      urgentStatus,
      urgenDialogVisible: false,
      ruleForm: {},
      rules: {
        express_no: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {},
  created() {
    this.urgentList();
  },
  methods: {
    urgentList() {
      this.$api.signInApi.urgentList(this.data).then((res) => {
        var hash = {};
        res.data.data.forEach(data => {


          data.order_purchase_express = data.order_purchase_express.reduce(function (item, next) {
            hash[next.express_no]
              ? ""
              : (hash[next.express_no] = true && item.push(next));

            return item;
          }, []);
        })
        this.tableData = res.data.data;
        this.total = res.data.total;
        console.log(res);
      });
    },
    // 收货-扫描签收
    receiveRefundStore() {
      this.$api.signInApi
        .receiveRefundStore({ express_no: this.express_no })
        .then((res) => {
          this.$message.success(res.msg);
          this.urgentList();
        });
    },
    // 搜索
    search() {
      this.data.page = 1;
      this.urgentList();
    },
    // 重置
    reset() {
      this.data = {
        page: 1,
        pageSize: 10,
        express_no: "",
        status: "0",
      };
      this.urgentList();
    },
    // 分页
    handleCurrentChange(val) {
      this.data.page = val;
      this.urgentList();
    },
    handleSizeChange(val) {
      this.data.pageSize = val;
      this.urgentList();
    },
    // 显示新增
    add() {
      this.urgenDialogVisible = true;
      this.ruleForm = {
        express_no: "",
        type: "",
        remark: "",
      };
    },
    // 新增
    urgentStore() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.signInApi.urgentStore(this.ruleForm).then((res) => {
            this.$message.success(res.msg);
            this.urgenDialogVisible = false;
            this.urgentList();
          });
        }
      });
    },
    // 删除
    urgentDelete(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.signInApi.urgentDelete({ id }).then((res) => {
            this.$message.success(res.msg);
            this.urgentList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin-bottom: 24px;
  display: flex;
  position: relative;
  justify-content: space-between;

  .entry {
    background-color: #ffa21d;
    border-color: #ffa21d;
  }

  .start {
    display: flex;
  }

  .end {
    display: flex;
  }

  .item {
    width: 220px;
    margin-right: 24px;

    /deep/.el-date-editor {
      width: 220px;
    }
  }

  .select {
    width: 140px;
  }

  .add {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.table {
  p {
    margin-bottom: 5px;

    .el-button {
      width: 80px;
      text-align: center;
      padding: 9px 0;
    }
  }
}

.content {
  padding: 0 15px;

  /deep/.el-select {
    width: 100%;
  }
}
</style>